import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useQuery } from '@tanstack/react-query';
import { Link, useParams } from 'react-router-dom';
import Loader from '../../../../components/Loader';
import NotFound from '../../../../components/NotFound';
import { myCasesPage } from '../../../../constants/pagesRoutesContants';
import { fetchMyCase } from '../../../../services/caseService';
import CaseDetails from '../caseDetails';
import styles from './style.module.scss';

function MyCase() {
    const { caseId = '' } = useParams();
    const basePath = myCasesPage.path;

    const { data: myCase, isPending } = useQuery({
        queryKey: ['getUserCase', caseId],
        queryFn: async () => {
            if (!caseId) {
                return null;
            }
            const { data } = await fetchMyCase(caseId);
            return data;
        },
    });

    if (isPending) {
        return <Loader />;
    }

    if (caseId.length === 0) {
        return (
            <>
                <div className={styles.header}>
                    <Link to={basePath}>
                        <FontAwesomeIcon icon={faArrowLeft} />
                    </Link>
                    <h1>Dossier</h1>
                </div>
                <NotFound />
            </>
        );
    }
    return (
        <CaseDetails caseId={caseId} userCase={myCase} basePath={basePath} />
    );
}

export default MyCase;
